import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';
import { error401Handler } from '@/utils/error';

const version = StFeatureFlagFlags.UserLegacyServiceVersionProd.getValue();
const gateway = StFeatureFlagFlags.gatewayProd.getValue();
const passkey = StFeatureFlagFlags.getProdPasskey.getValue();

const afterParser = response => response.data;

export class UniverseService extends Service {
  constructor(gateway, version) {
    const api = createApi(`panels-service/${version}/panels/`, gateway, { error401Handler });
    super(api, { afterParser });
  }

  panels({ accountId, universeId }) {
    return this.find({ url: `${accountId}/${universeId}?fields=name&from_datastore=true&passkey=${passkey}` });
  }
}

export default new UniverseService(gateway, version);
